import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const selfAssessmentSlice = createSlice({
  name: 'selfAssessment',
  initialState,
  reducers: {
    fetchSelfAssessmentRequest(state, action) {
      state.loading = true;
      state.error = null;
    },
    fetchSelfAssessmentSuccess(state, action) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchSelfAssessmentFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { fetchSelfAssessmentRequest, fetchSelfAssessmentSuccess, fetchSelfAssessmentFailure } = selfAssessmentSlice.actions;

export default selfAssessmentSlice.reducer;
